import axios from "axios";
import AxiosClient from "../AxiosClient";

export const getReportSave = (params) => {
  const url = "/api/reportSave/searchInfoList";
  return AxiosClient.post(url, params);
};

export const getPreview = (params) => {
  const url = "/api/report/preview";
  // return AxiosClient.post(url, params);
  return AxiosClient.post(url, params, {
    responseType: "arraybuffer",
    timeout: 600000, // 10分でTimeOutエラー出す
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

export const printReport = (params) => {
  const url = "/api/report/print";
  return AxiosClient.post(url, params, {
    responseType: "arraybuffer",
    timeout: 600000, // 10分でTimeOutエラー出す
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      // The code here will execute only for status codes 2xx
      return response;
    })
    .catch((error) => {
      // The code here will execute for status codes outside the range of 2xx
      if (error.response && error.response.status === 400) {
        alert("出力データがありません。");
      } else alert("出力できませんでした。");
      console.error("Error:", error);
      throw error;
    });
};
